const grade_0 = {
  label: "Kindergarten",
  subjects: {
    applied_design_0: {
  label: "Applied Design (Kindergarten)",
  topics: [
    // { value: "defining", label: "Defining" },
    { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
  ],
  competencies: {
    core: [
       { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
    ],
    sub: {
      applied_design: [
        // Defining
        {
          value: "identify_needs_opportunities",
          label: "Identify needs and opportunities for designing, through exploration"
        },

        // Ideating
        {
          value: "generate_ideas",
          label: "Generate ideas from their experiences and interests"
        },
        {
          value: "add_to_others_ideas",
          label: "Add to others’ ideas"
        },
        {
          value: "choose_idea",
          label: "Choose an idea to pursue"
        },

        // Prototyping
        {
          value: "choose_tools_materials",
          label: "Choose tools and materials"
        },
        {
          value: "make_product",
          label: "Make a product using known procedures or through modelling of others"
        },

        // Testing
        {
          value: "trial_and_error",
          label: "Use trial and error to make changes, solve problems, or incorporate new ideas from self or others"
        },

        // Making
        {
          value: "decide_sharing",
          label: "Decide on how and with whom to share their product"
        },

        // Sharing
        {
          value: "demonstrate_product",
          label: "Demonstrate their product, tell the story of designing and making their product, and explain how their product contributes to the individual, family, community, and/or environment"
        },
        {
          value: "evaluate_design_solution",
          label: "Use personal preferences to evaluate the success of their design solutions"
        },
        {
          value: "reflect_on_ability",
          label: "Reflect on their ability to work effectively both as individuals and collaboratively in a group"
        }
      ],

      applied_skills: [
        {
          value: "safe_use_tools",
          label: "Use materials, tools, and technologies in a safe manner in both physical and digital environments"
        },
        {
          value: "develop_skills_play",
          label: "Develop their skills and add new ones through play and collaborative work"
        }
      ],

      applied_technologies: [
        {
          value: "explore_simple_tools",
          label: "Explore the use of simple, available tools and technologies to extend their capabilities"
        }
      ]
    }
  }
},

    arts_0: {
      label: "Arts Education(Kindergarten)",
      topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],
        sub: {
          Exploring: [
            { value: "explore_elements", label: "Explore elements, processes, materials, movements, technologies, tools, and techniques of the arts" },
            { value: "create_artworks", label: "Create artistic works collaboratively and individually using imagination, inquiry, experimentation, and purposeful play" },
            { value: "explore_expression", label: "Explore artistic expressions of themselves and the community through creative processes" }
          ],
          Reasoning: [
            { value: "observe_artists", label: "Observe and share how artists use processes, materials, movements, technologies, tools, and techniques" },
            { value: "develop_skills", label: "Develop processes and technical skills in various art forms to nurture motivation and imagination" },
            { value: "reflect_process", label: "Reflect on creative processes and connect them to other experiences" }
          ],
          Communicating: [
            { value: "interpret_symbols", label: "Interpret how symbols are used through the arts" },
            { value: "express_through_art", label: "Express feelings, ideas, stories, observations, and experiences through the arts" },
            { value: "respond_to_art", label: "Describe and respond to works of art" }
          ],
          Connecting: [
            { value: "share_creative_works", label: "Experience, document, and share creative works in various ways" },
            { value: "engage_content", label: "Demonstrate increasingly sophisticated engagement with curricular content" }
          ]
        }
      }
    },

    career_education_0: {
      label: 'Career Education (Kindergarten)',
      topics: [],
      competencies: {
        core: [
          { value: 'examine', label: 'Examine' },
          { value: 'interact', label: 'Interact' },
          { value: 'experience', label: 'Experience' },
          { value: 'initiate', label: 'Initiate' },
          { value: 'share', label: 'Share' }
        ],
        sub: {
          examine: [
            { value: 'identify_and_appreciate_personal_attributes', label: 'Identify and appreciate their personal attributes, skills, interests, and accomplishments' },
            { value: 'demonstrate_effective_work_habits', label: 'Demonstrate effective work habits and organizational skills appropriate to their level of development' }
          ],
          interact: [
            { value: 'work_respectfully_and_constructively', label: 'Work respectfully and constructively with others to achieve common goals' },
            { value: 'identify_and_appreciate_roles_and_responsibilities', label: 'Identify and appreciate the roles and responsibilities of people in their schools, families, and communities' },
            { value: 'recognize_the_importance_of_positive_relationships', label: 'Recognize the importance of positive relationships in their lives' }
          ],
          experience: [
            { value: 'recognize_the_importance_of_learning', label: 'Recognize the importance of learning in their lives and future careers' }
          ],
          initiate: [
            { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals for themselves' }
          ],
          share: [
            { value: 'share_ideas_information_feelings_and_knowledge', label: 'Share ideas, information, personal feelings, and knowledge with others' },
            { value: 'recognize_the_basic_skills_required', label: 'Recognize the basic skills required in a variety of jobs in the community' }
          ]
        }
      }
    },

  "english_0": {
    "label": "English Language Arts (Kindergarten)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "use_sources_prior_knowledge",
            "label": "Use sources of information and prior knowledge to make meaning (K-3)"
          },
          {
            "value": "use_read_listen_view_strategies",
            "label": "Use developmentally appropriate reading, listening, and viewing strategies to make meaning (K-3)"
          },
          {
            "value": "explore_foundational_concepts",
            "label": "Explore foundational concepts of print, oral, and visual texts"
          },
          {
            "value": "engage_actively",
            "label": "Engage actively as listeners, viewers, and readers to develop understanding of self, identity, and community (K-3)"
          },
          {
            "value": "recognize_importance_of_story",
            "label": "Recognize the importance of story in personal, family, and community identity (K-1)"
          },
          {
            "value": "use_personal_experience_connections",
            "label": "Use personal experience and knowledge to connect to stories and other texts to make meaning (K-2)"
          },
          {
            "value": "recognize_structure_of_story",
            "label": "Recognize the structure of story"
          }
        ],
        "create_communicate": [
          {
            "value": "exchange_ideas_perspectives",
            "label": "Exchange ideas and perspectives to build shared understanding (K-5)"
          },
          {
            "value": "use_language_to_share",
            "label": "Use language to identify, create, and share ideas, feelings, opinions, and preferences"
          },
          {
            "value": "create_stories_texts_awareness",
            "label": "Create stories and other texts to deepen awareness of self, family, and community (K-3)"
          },
          {
            "value": "plan_create_stories_texts",
            "label": "Plan and create stories and other texts for different purposes and audiences"
          },
          {
            "value": "explore_oral_storytelling",
            "label": "Explore oral storytelling processes (K-2)"
          }
        ]
      }
    }
  }
,
 
"math_0": {
    "label": "Mathematics (Kindergarten)",
    "topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_reasoning_make_connections_k5",
            "label": "Use reasoning to explore and make connections"
          },
          {
            "value": "estimate_reasonably_k5",
            "label": "Estimate reasonably"
          },
          {
            "value": "develop_mental_math_strategies_k5",
            "label": "Develop mental math strategies and abilities to make sense of quantities"
          },
          {
            "value": "use_technology_explore_math_k5",
            "label": "Use technology to explore mathematics"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_k5",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_understanding_play_inquiry_k5",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_k5",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "use_multiple_problem_solving_strategies_k5",
            "label": "Develop and use multiple strategies to engage in problem solving"
          },
          {
            "value": "connect_problem_solving_local_culture_k5",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "communicate_math_thinking_k5",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "use_math_vocabulary_k5",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_k5",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "represent_math_ideas_k5",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_k5",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_k5",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "incorporate_first_peoples_perspectives_k5",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  },



  "phe_k": {
    "label": "Physical and Health Education (Kindergarten)",
    "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "fundamental_movement_skills_k",
            "label": "Develop and demonstrate a variety of fundamental movement skills in a variety of physical activities and environments (K–2)"
          },
          {
            "value": "describe_body_reaction_k",
            "label": "Describe the body’s reaction to participating in physical activity in a variety of environments (K–1)"
          },
          {
            "value": "safety_fair_play_leadership_k",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_k",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–4)"
          },
          {
            "value": "identify_opportunities_activity_k",
            "label": "Identify opportunities to be physically active at school, at home, and in the community (K–1)"
          },
          {
            "value": "identify_explore_foods_k",
            "label": "Identify and explore a variety of foods and describe how they contribute to health (K–1)"
          },
          {
            "value": "identify_choices_health_k",
            "label": "Identify opportunities to make choices that contribute to health and well-being (K–1)"
          },
          {
            "value": "identify_sources_health_info_k",
            "label": "Identify sources of health information"
          }
        ],

        "social_community_health": [
          {
            "value": "identify_unsafe_situations_k",
            "label": "Identify and describe a variety of unsafe and/or uncomfortable situations"
          },
          {
            "value": "demonstrate_respectful_behaviour_k",
            "label": "Develop and demonstrate respectful behaviour when participating in activities with others (K–2)"
          },
          {
            "value": "identify_caring_behaviours_k",
            "label": "Identify caring behaviours among classmates and within families (K–1)"
          }
        ],

        "mental_well_being": [
          {
            "value": "practices_promote_mental_well_being_k",
            "label": "Identify and describe practices that promote mental well-being (K–1)"
          },
          {
            "value": "identify_feelings_worries_k",
            "label": "Identify and describe feelings and worries (K–1)"
          },
          {
            "value": "identify_personal_skills_interests_k",
            "label": "Identify personal skills, interests, and preferences (K–1)"
          }
        ]
      }
    }
  },

    
  

    science_0: {
      label: "Science (Kindergarten)",
      topics: [
        { value: "living_things", label: "Living and Non-Living Things" },
        { value: "weather", label: "Weather Patterns" },
        { value: "senses", label: "Five Senses" }
      ],
      competencies: {
        core: [
          { value: "Predicting", label: "Questioning and Predicting" },
          { value: "Conducting", label: "Planning and Conducting" },
          { value: "Processing", label: "Processing and Analyzing Data and Information" },
          { value: "Evaluating", label: "Evaluating" },
          { value: "Applying", label: "Applying and Innovating" },
          { value: "Communicating", label: "Communicating" },
        ],
        sub: {
          Predicting: [
            { value: "using_senses", label: "Demonstrate curiosity and a sense of wonder about the world" },
            { value: "describing", label: "Observe objects and events in familiar contexts" },
            { value: "recording", label: "Ask questions about familiar objects and events" },
            { value: "recording", label: "Make simple predictions about familiar objects and events" }
          ],
          Conducting: [
            { value: "asking_questions", label: "Make and record observations" },
            { value: "making_predictions", label: "Safely manipulate materials to test ideas and predictions" },
            { value: "exploring", label: "Make and record simple measurements using informal or non-standard methods" }
          ],
          Processing: [
            { value: "using_senses", label: "Experience and interpret the local environment" },
            { value: "describing", label: "Recognize First Peoples stories, songs, and art as ways to share knowledge" },
            { value: "recording", label: "Sort and classify data and information using drawings, pictographs, and provided tables" },
            { value: "recording", label: "Compare observations with predictions through discussion" },
            { value: "recording", label: "Identify simple patterns and connections" },
            { value: "recording", label: "Compare observations with those of others" }
          ],
          Innovatinguating: [
            { value: "asking_questions", label: "Take part in caring for self, family, classroom, and school through personal approaches" },
            { value: "making_predictions", label: "Transfer and apply learning to new situations" },
            { value: "exploring", label: "Generate and introduce new or refined ideas when problem solving" }
          ],
          Evaluating: [
            { value: "using_senses", label: "Consider some environmental consequences of their actions" },
          ],
          Applying: [
            { value: "asking_questions", label: "Asking Questions" },
            { value: "making_predictions", label: "Making Predictions" },
            { value: "exploring", label: "Hands-on Exploration" }
          ],
          Communicating: [
            { value: "using_senses", label: "Communicate observations and ideas using oral or written language, drawing, or role-play" },
            { value: "describing", label: "Express and reflect on personal experiences of place" },
          ],
        }
      }
    },

   

    

    
  "social_studies_0": {
    "label": "Social Studies (Kindergarten)",
    "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],

      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_k",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "explain_significance_k",
            "label": "Explain the significance of personal or local events, objects, people, or places"
          }
        ],

        "evidence": [
          {
            "value": "ask_infer_conclude_k",
            "label": "Ask questions, make inferences, and draw conclusions about the content and features of different types of sources"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_distinguish_change_k",
            "label": "Sequence objects, images, or events, and distinguish between what has changed and what has stayed the same"
          }
        ],

        "cause_consequence": [
          {
            "value": "recognize_cause_effect_k",
            "label": "Recognize causes and consequences of events, decisions, or developments in their lives"
          }
        ],

        "perspective": [
          {
            "value": "acknowledge_different_perspectives_k",
            "label": "Acknowledge different perspectives on people, places, issues, or events in their lives"
          }
        ],

        "ethical_judgement": [
          {
            "value": "identify_fair_unfair_k",
            "label": "Identify fair and unfair aspects of events, decisions, or actions in their lives and consider appropriate courses of action"
          }
        ]
      }
    }
  },
  
  





    


  }
};

export default grade_0;
